import React, { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import "./custom.css";
import PrivateRoute from "./Components/PrivateRoute";
import Login from "./Pages/Login";
import Error from "./Pages/Error";
import AppContextProvider from "./Contexts/AppContextProvider";
import Dashboard from "./Pages/Patient/Dashboard";
import ManageAbstractors from "./Pages/Abstractor/ManageAbstractors";
import { ManageCenters } from "./Pages/Center/ManageCenters";
import ResetPassword from "./Pages/ResetPassword";
import PasswordRecovery from "./Pages/PasswordRecovery";
import { AddLocalStorageData, GetLocalStorageData } from "./Helpers/Utilities";
import packageJson from "../package.json";
import ValidateSubmit from "./Pages/Patient/ValidateSubmit";
import PatientScreening from "./Pages/Patient/PatientScreening";
import EligibilityCriteria from "./Pages/Patient/EligibilityCriteria";
import Demographics from "./Pages/Patient/Demographics";
import TransplantCharacteristics from "./Pages/Patient/TransplantCharacteristics";
import Hospitalizations from "./Pages/Patient/Hospitalizations";
import MMARelatedComplications from "./Pages/Patient/MMARelatedComplications";
import ClinicalCharacteristics from "./Pages/Patient/ClinicalCharacteristics";
import NonMDETreatment from "./Pages/Patient/NonMDETreatment";
import NutritionManagement from "./Pages/Patient/NutritionManagement";
import MMALabAssessment from "./Pages/Patient/MMALabAssessment";
import RenalLabAssessment from "./Pages/Patient/RenalLabAssessment";
import OtherLabAssessment from "./Pages/Patient/OtherLabAssessment";
import MDESForm from './Pages/MDE/MDESForm';
import MDESInformation from './Pages/MDE/MDESInformation';
import MDEInfoPage from "./Pages/MDE/MDEInfoPage";
import AbbreviationList from "./Pages/Patient/AbbreviationList";

const App = () => {
    const location = useLocation();
    /* <summary>
    date: 06-04-2024
    Name: AP
    description: Effect to clear the cache
    <summary>*/
    useEffect(() => {
        const Caching = () => {
            const version = GetLocalStorageData("version");
            if (version !== packageJson.version) {
                AddLocalStorageData("version", packageJson.version);
                if ("caches" in window) {
                    caches.keys().then((names) => {
                        // Delete all the cache files
                        names.forEach((name) => {
                            caches.delete(name);
                        });
                    });
                }

                // Makes sure the page reloads. Changes are only visible after you refresh.
                window.location.replace(window.location.href);
            }
        };

        Caching();

        return () => { };
    }, []);
    return (
        <AppContextProvider>
            <Routes location={location} key={location.pathname}>
                <Route path="/" element={<Login />} />
                <Route path="/ResetPassword" element={<ResetPassword />} />
                <Route path="/PasswordRecovery" element={<PasswordRecovery />} />
                <Route path="/" element={<PrivateRoute />}>
                    <Route path="/ManagePatients" element={<Dashboard />} />
                    <Route path="/ManageAbstractors" element={<ManageAbstractors />} />
                    <Route path="/ManageCenters" element={<ManageCenters />} />
                    <Route path="/ValidateSubmit" element={<ValidateSubmit />} />
                    <Route path="/PatientScreening" element={<PatientScreening />} />
                    <Route path="/ClinicalCharacteristics" element={<ClinicalCharacteristics />} />
                    <Route path="/EligibilityCriteria" element={<EligibilityCriteria />} />
                    <Route path="/Demographics" element={<Demographics />} />
                    <Route path="/TransplantCharacteristics" element={<TransplantCharacteristics />} />
                    <Route path="/MDESForm" element={<MDESForm />} />
                    <Route path="/MDESInformation/:mdeNo" element={<MDESInformation />} />
                    <Route path="/Hospitalizations" element={<Hospitalizations />} />
                    <Route path="/NonMDETreatment" element={<NonMDETreatment />} />
                    <Route path="/MMALabAssessment" element={<MMALabAssessment />} />
                    <Route path="/RenalLabAssessment" element={<RenalLabAssessment />} />
                    <Route path="/OtherLabAssessment" element={<OtherLabAssessment />} />
                    <Route path="/MMARelatedComplications" element={<MMARelatedComplications />} />
                    <Route path="/NutritionManagement" element={<NutritionManagement />} />
                    <Route path="/MDEInfo" element={<MDEInfoPage />} />
                    <Route path="/AbbreviationList" element={<AbbreviationList />} />


                </Route>
                <Route path="*" element={<Error />} />
            </Routes>
        </AppContextProvider>
    );
};
export default App;
